import { StyleSheet, View } from "react-native";
import { BackgroundGradient } from "~/components/layout/BackgroundGradient";
import { QendoIcon, type QendoIconSet } from "~/components/QendoIcon";
import { Rounded } from "~/constants/layout";
import { useTheme } from "~/providers/ThemeProvider";

type HomeIconProps = {
    icon: QendoIconSet;
};

export const HomeIcon = ({ icon }: HomeIconProps) => {
    const { colours, border } = useTheme();

    return (
        <View style={[styles.container, border.brand]}>
            <BackgroundGradient style={Rounded.full} />
            <QendoIcon name={icon} size={32} color={colours.brandHighlight} />
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        borderRadius: 9999,
        borderWidth: 1,
        overflow: "hidden",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        position: "relative",
        width: 64,
        height: 64,
    },
});
